import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/index.css";
import App from "./App";
import { RoleProvider } from "./context/RoleContext";
import { ThemeProvider, applyStoredTheme, useTheme } from "./context/ThemeContext";

applyStoredTheme();

function ThemedToasts() {
  const { theme } = useTheme();
  return <ToastContainer position="top-right" autoClose={6000} hideProgressBar newestOnTop closeOnClick theme={theme === "dark" ? "dark" : "light"} />;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <RoleProvider>
        <ThemeProvider>
          <App />
          <ThemedToasts />
        </ThemeProvider>
      </RoleProvider>
    </BrowserRouter>
  </React.StrictMode>
);
